import { useEffect } from "react"

const useLockBodyScroll = (isLocked) => {
  useEffect(() => {
    if (isLocked) document.body.style.overflow = `hidden`
    else document.body.style.overflow = `visible`
  })
}

export default useLockBodyScroll